import { Text } from "@kvix/ui";
import React, { Fragment, useCallback, useContext } from "react";
import { useTranslation } from "react-i18next";
import { PaymentContext } from "../context";
import { getPlanDetails } from "../i18n";

interface Props {
  planIds: string[];
}

export const PlanList: React.FC<Props> = (props) => {
  const { t, ready } = useTranslation();
  const { availablePlans } = useContext(PaymentContext);

  const getPlanInterval = useCallback(
    (id: string) => {
      const plan = availablePlans.find((plan) => plan.id === id);

      if (plan) {
        return getPlanDetails(plan).title;
      }
    },
    [availablePlans]
  );

  const titles = props.planIds.map(getPlanInterval);

  if (!ready) {
    return null;
  }

  return (
    <Text
      component="span"
      variant="body2"
      weight={600}
      style={{ textDecoration: "underline" }}
    >
      {titles.map((title, index) => (
        <Fragment key={index}>
          {t(title)}
          {index > 0 && ", "}
        </Fragment>
      ))}
    </Text>
  );
};
